import { render, staticRenderFns } from "./S5.vue?vue&type=template&id=4766ccdf&scoped=true&"
import script from "./S5.vue?vue&type=script&lang=js&"
export * from "./S5.vue?vue&type=script&lang=js&"
import style0 from "./S5.vue?vue&type=style&index=0&id=4766ccdf&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4766ccdf",
  null
  
)

export default component.exports